<template>
  <div class="wrapper">
    <h3>エネルギー消費性能計算プログラム</h3>
    <div class="bl_programFlex jutaku">
        <div class="bl_programFlex_container">
            <div class="flex_wrap">
                <router-link
                    to="/simple"
                    class="btn_simple"
                >
                    <span class="btn_simple_jutaku">住宅版</span>簡易入力画面<span class="btn_simple_cap">基本設備を選ぶだけで計算</span>
                </router-link>
                <router-link
                    to="/detail"
                    class="btn_detail"
                >
                    <span class="btn_simple_jutaku">住宅版<br />
                        <span class="btn_detail_jutaku">気候風土適応住宅版</span><span class="btn_detail_jutaku">特定建築主基準版</span>
                    </span>
                    詳細入力画面<span class="btn_simple_cap">詳しい仕様を入力して計算</span>
                </router-link>
                <h3 class="red_box">
                    <ul>
                        <li>エネルギー消費性能計算プログラム（住宅版）には、簡易入力画面と詳細入力画面の二つの入力画面があります。</li>
                        <li>簡易入力画面と詳細入力画面は、入力できる項目が異なりますが、プログラムは同じです。どちらの入力画面を使用しても設定条件が同じであれば、同じ計算結果が得られます。
                            <a
                                href="https://house.lowenergy.jp/program#solar_radiation_area"
                                target="_blank"
                                class="target_blank"
                            >
                                補足資料
                            </a>
                        </li>
                        <li>
                            簡易入力画面で入力した後に、詳細入力画面に移動することができます。この時、簡易入力画面で入力した内容は、詳細入力画面に反映されます。
                        </li>
                    </ul>
                </h3>
            </div>
        </div>
        <div
            @click="toggleDifference"
            :class="{'btn_toggleDifference__open':isShowDifference}"
            class="btn_toggleDifference"
            >簡易入力画面と詳細入力画面の違い
        </div>
        <div v-if="isShowDifference" @click="toggleDifference" class="info_container">
            <div class="chigai">
                <h4>簡易入力画面 と 詳細入力画面 の違い</h4>
                <h5>詳細入力画面では以下の入力を行うことができます。</h5>
            </div>
            <div class="w100">
                <div class="w50">
                    <h4>簡易入力画面では扱いのない要素技術</h4>
                    <ul>
                        <li>通風の利用</li>
                        <li>蓄熱の利用</li>
                        <li>床下空間を経由して外気を導入する換気方式の利用</li>
                        <li>電気ヒーター床暖房、ルームエアコンディショナー付温水床暖房機および温水床暖房</li>
                        <li>熱交換型換気設備</li>
                        <li>太陽光発電設備</li>
                        <li>液体集熱式太陽熱利用設備</li>
                        <li>空気集熱式太陽熱利用設備</li>
                        <li>コージェネレーション設備</li>
                    </ul>
                </div>
                <div class="w50">
                    <h4>各種設備機器の詳細な仕様</h4>
                    <ul>
                        <li>機器のエネルギー消費性能
                            <ul>
                                <li>エネルギー消費効率、定格能力・定格消費電力 など</li>
                            </ul>
                        </li>
                        <li>各種省エネルギー手法・対策
                            <ul>
                                <li><span class="category">暖房</span>配管・配管経路の断熱（温水式の場合）など</li>
                                <li><span class="category">暖房/冷房</span>VAV方式（住戸全体を暖房／冷房する場合） など</li>
                                <li><span class="category">換気</span>直流モーター（ダクト式の場合） など</li>
                                <li><span class="category">給湯</span>節湯水栓、浴槽の保温措置 など</li>
                                <li><span class="category">照明</span>多灯分散照明方式、調光 など</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <information-box
                    class="w100"
                    title="上記の要素技術および詳細仕様は、次のいずれかの方法により計算できます。">
                    <ol>
                        <li>詳細入力画面で全ての入力を行い、計算する。</li>
                        <li>簡易入力画面で基本的な入力（上記の要素技術・詳細仕様以外の入力）を終えた後に、詳細入力画面に移動して必要な項目のみ追加で入力を行い、計算する。</li>
                    </ol><p>2の方法は、 1の方法よりも少ない入力項目で上記の要素技術や詳細仕様を計算できます。</p>
                </information-box>
            </div>
        </div>
    </div>
  </div>
</template>


<script>
/**
 * 入力方法選択画面
 * 
 * [データ]
 * isProduction ... 環境が本番環境かどうかを判定
 */
export default {
    name:"SelectRoot",
    data(){
        return {
            /**
             * 環境が本番環境かどうかを判定
             */
            isProduction: process.env.NODE_ENV === 'production',
            /**
             * 入力画面の違いのアコーディオンの状態を管理
             */
            isShowDifference: false
        }
    },
    methods:{
        toggleDifference(){
            this.isShowDifference = !this.isShowDifference
        }
    }
}
</script>

<style scoped>
h3{
    display: block;
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
    color: #41B8D4;
}
h3 + p{
    display: block;
    width: 80%;
    margin: 0 auto;
    text-align: center;
}
h4{
    font-size: 18px;
    line-height: 18px;
    margin: 8px 16px 4px;
}
.attention{
    width: 80%;
	display: flex;
	flex-direction: column;
	text-align: center;
	margin: 32px auto;
}
.attention ul{
    padding-inline-start: 0;
    padding-left: 0;
}
.attention ul li{
    list-style-type: none;
}
.bl_programFlex{
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-bottom:#41B8D4 1px solid;
    width: 90%;
    margin: 16px auto;
}

.bl_programFlex.jutaku{
    padding-top: 16px;
    border-top:#41B8D4 1px solid;
}
.bl_programFlex_container .flex_wrap{
    justify-content: center;
}
.flex_wrap >>> a:not(.not_yet):hover{
    transform: scale(1.05);
}

.flex_wrap >>> a .btn_simple_jutaku{
    margin-top: 16px;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
}
.flex_wrap >>> .btn_detail_jutaku{
    display:flex;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    margin: 4px 0 0;
    text-align: center;
}
.flex_wrap >>> a.btn_simple{
    color: white;
    background: linear-gradient(180deg, #41B8D4 0%, #6DC7DD 100%);
    box-shadow: 0 3px 8px 2px rgba(28, 67, 115, 0.3);
}
.flex_wrap >>> a span.btn_simple_cap{
    padding: 4px 32px;
    font-size: 12px;
    letter-spacing: 1px;
    white-space: nowrap;
    color:white;
    background-color: #1c4373;
}
.flex_wrap >>> a.btn_detail{
    color: white;
    background: linear-gradient(180deg, #1c4373 0%, #205383 100%);
    box-shadow: 0 3px 8px 2px rgba(28, 67, 115, 0.3);
}
.flex_wrap >>> a.btn_detail span.btn_simple_cap{
    margin-top: 12px;
    color:white;
    background-color: #41B8D4;
}
.flex_wrap >>> a.btn_detail.not_yet:after{
    content: "準備中";
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 150px;
    color: white;
    background-color: rgba(100, 100, 100, 0.8);
    border-radius: 8px;
    top:0;
    left:0;
    position: absolute;
    cursor: default;
}
.red_box{
	width: 100%;
    margin-top: 16px;
	color: #F07466;
	font-size: 13px;
	font-weight: bolder;
	text-align: left;
}
.jutaku li{
    margin-bottom: 8px;
}
.jutaku .btn_toggleDifference{
    display:inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 30px;
    margin: 16px auto;
    padding: 4px 8px;
    color: #1c4373;
    background-color: #e0e0e0;
    font-size: 12px;
    font-weight: bolder;
    border-radius: 10px;
    cursor: pointer;
}
.jutaku .btn_toggleDifference__open{
    margin-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.jutaku .btn_toggleDifference:hover{
    color:#1c4373;
    background-color: #41B8D4;
}
.jutaku .btn_toggleDifference:before{
    content:"?";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    border: 2px currentColor solid;
    border-radius: 10px;
    font-size: 12px;
}
.jutaku >>> a.btn_simple,
.jutaku >>> a.btn_detail{
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    width: 48%;
    max-width: 380px;
    min-width: 300px;
    height: 200px;
    margin: 16px;
    padding: 16px;
    font-size: 28px;
    letter-spacing: 2px;
    font-weight: bolder;
    color: white;
    background-color: #aaa;
    border-radius: 20px;
    position: relative;
}
.jutaku .btn_detail >>>.btn_simple_jutaku{
    margin-top:8px;
}
.jutaku a.target_blank{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: auto;
    height: 1.5em;
    margin-top: 4px;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bolder;
    text-align: center;
    color: #1C4373;
    background-color: #efefef;
    border-radius: 8px;
    box-shadow: none;
    cursor: pointer;
}
.jutaku a.target_blank:hover{
    color:#1c4373;
    background-color: #41B8D4;
    transform: scale(1.05);
}
.jutaku a.target_blank:after{
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(/img/all_icons.png) no-repeat;
    background-size: auto calc( 225 / 72 * 100% );
    background-position-x: calc(142 / (1725 - 1015) * 100%);
    background-position-y: calc(120 / (225 - 72) * 100%);
}
.info_container{
	display: flex;
	flex-direction: column;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
	text-align: center;
    background-color: rgba(0,0,0,.05);
    border-radius: 0 0 20px 20px;
    cursor:pointer;
    overflow: hidden;
}
.chigai{
	display: flex;
	flex-direction: column;
	width: 90%;
    margin: 32px auto 16px;
}
.chigai h4{
	display: block;
    width: auto;
	margin: 4px;
	padding: 0 32px;
	text-align: center;
}
.chigai h5{
    margin: 0;
	padding: 4px 32px;
	font-size: 13px;
	border-top: 2px solid #ccc;
}
.w100{
	display: flex;
	flex-direction: row;
    flex-wrap: wrap;
	text-align: left;
    padding: 16px 64px;
}
.w100>.w100{
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
}
.w100 >>> .information{
    width: 95%;
    margin: 8px auto;
    border: 1px #1C4373 solid;
    box-sizing: border-box;
}
.w50{
    box-sizing: border-box;
    width: 50%;
    padding: 0 16px;
}
.w50>ul{
    padding-inline-start: 20px;
}
.w50>ul li{
	list-style-type: disc;
}
.w50>ul li>ul{
    padding-inline-start: 0;
	margin-top: 0;
}
.w50>ul li>ul li{
	list-style-type: none;
	font-size: 14px;
}
.info_container .category{
	display: inline-block;
	width: 5.5em;
	margin-right: 4px;
	padding: 2px 2px;
	font-size: 10px;
	text-align: center;
	line-height: 10px;
	white-space: nowrap;
	color: white;
	background-color: #555;
}
.top-enter-active, .top-leave-active {
  transform: scale(1,1); 
  transform-origin: 0 0;
  transition: transform 225ms ease-in-out 0ms;
}

.top-enter, .top-leave-to {
  transform:  scale(1,0); 
}
.bl_announcement{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

}

@media screen and (max-width: 1000px) {
    .bl_programFlex{
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;/* IE11 */
    }
    .jutaku.bl_programFlex {
        grid-template-rows: auto auto auto auto auto;
        -ms-grid-rows: auto auto auto auto auto;
    }
    .jutaku.bl_programFlex .btn_toggleDifference{
        width: 90%;
        margin-right: auto;
        margin-left: auto;
        grid-row: 4;
        -ms-grid-row: 4;
    }
    .jutaku.bl_programFlex .info_container{
        grid-row: 5;
        -ms-grid-row: 5;
    }
    .jutaku >>> a,
    .kikofudo >>> a,
    .tokuteikenchikunushi >>> a{
        margin-bottom: 16px;
    }
    .w100{
        width: 100%;
        max-width: 95vw;
    }
}
@media screen and (max-width: 700px) {
    .flex_center{
        flex-direction: column;
        align-items: center;
    }
    .w100{
        flex-direction: column;
    }
    .w50{
        width: 100%;
        margin-bottom: 32px;
    }
}
</style>


